import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const ApprovalEditPanelNextButtonTooltip = props => {
  const {
    numberOfApprovers,
    numberOfChanges
  } = props;
  if (numberOfChanges < 1) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "productApprovals.ApprovalEditPanel.tooltipNoChanges"
    });
  }
  if (numberOfApprovers < 1) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "productApprovals.ApprovalEditPanel.tooltipNoApprovers"
    });
  }
  if (numberOfApprovers > 10) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "productApprovals.ApprovalEditPanel.tooltipTooManyApprovers"
    });
  }
  return null;
};
export default ApprovalEditPanelNextButtonTooltip;